<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/consumables/consumables-list' }">耗材管理</el-breadcrumb-item>
          <el-breadcrumb-item >耗材入库</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="cons-add">
      <dv-border-box-12 style="padding: 5px 0px;">
        <div style="padding:1px 6px 0px 6px">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">耗材录入</div>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="100px"
            class="add-form"
            :rules="rules"
            ref="form"
            >
            <el-form-item label="耗材UDI" prop="cons_udi">
                <div style="display: flex;flex-direction: row;">
                  <!-- <span style="margin-right: 10px;color: #00FFFF;">第一条条形码:</span> -->
                  <el-input id="cons_udi" v-model="form.cons_udi" placeholder="UDI为数字和字母,共24位" style="width: 500px;" oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')">
                    <!-- oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')" -->
                    <!-- oninput="value=value.replace(/[^\d]/g,'')" -->
                    <!-- //手动输入或点击右侧选择图片自动识别, UDI为24位纯数字 -->
                  </el-input>
                  <!-- <input style="margin-top: 10px;margin-left: 5px;" id="pictureD_file" accept="image/*" type="file" capture="camera" name="pictureD_file" @change="handleFiles($event)" /> -->
                </div>
            </el-form-item>
            <el-form-item label="入库日期" prop="entranceDate" style="margin-top: 40px;">
              <!--
              <el-input v-model="form.cons_date" placeholder="" :readonly="true" style="width: 400px;">
              </el-input> -->
               <el-date-picker
                    id="entranceDate"
                    v-model="form.entranceDate"
                    type="date"
                    placeholder="点击选择入库日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="action-button" @click="submitForm('form')">立即保存</el-button>
              <el-button class="action-button" @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </dv-border-box-12>


    </div>

  </div>
</template>

<script>
  // import Quagga from 'quagga'

  export default {
    data() {
      return {
        form: {
          cons_udi: '',
          entranceDate:'',//入库日期
        },
        rules: {
          cons_udi: [{ required: true, message: '请输入耗材UDI', trigger: 'blur' },{min: 24,max:24,message:'请输入24位数字和字母组合'}],
          entranceDate: [{ required: true, message: '请选择入库日期', trigger: 'blur' }],
        }
      }
    },
    methods: {
      goBack(){
        this.$router.back()
      },
      //识别设备UDI二维码
      // handleFiles($event){
      //   let files = $event.target.files[0]
      //   let that = this
      //   if(files){
      //     let reader = new FileReader()
      //     reader.readAsDataURL(files)
      //     reader.onloadend = function(){
      //       let img = new Image()
      //       img.src = reader.result
      //       that.init(img.src);
      //     }
      //   }
      // },

      // init(src){
      //   let that = this
      //   const config = {
      //     locator: {
      //       patchSize: 'medium',
      //       halfSample: true
      //     },
      //     numOfWorkers:(navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4),
      //     decoder : {
      //       readers: ['code_128_reader','ean_reader','ean_8_reader','codabar_reader','code_39_reader','code_39_vin_reader','upc_reader','upc_e_reader','i2of5_reader'],
      //     },
      //     locate: true,
      //     src:src
      //   }

      //   Quagga.decodeSingle(config,function(result) {
      //     if(!result){
      //       that.$message({
      //         message:'未识别到条形码',
      //         type:'warning'
      //       })
      //       return false;
      //     }else if(result.codeResult){
      //       ////识别结果
      //         const code2 = result.codeResult.code;
      //         if(code2.length == 24){
      //           // const part1 = '(' + code2.substring(0,2) + ')' + code2.substring(2,8)
      //           // const part2 = '(' + code2.substring(8,10) + ')' + code2.substring(10,20)
      //           // const part3 = '(' + code2.substring(20,22) + ')' + code2.substring(22,24)
      //           // that.form.cons_udi = part1 + part2 + part3;
      //           that.form.cons_udi = code2;
      //         }else{
      //           that.$message({
      //             message:'条形码不合规，请确认后再保存',
      //             type:'warning'
      //           })
      //           that.form.cons_udi = code2;
      //         }
      //     }else{
      //       that.$message({
      //         message:'未识别到条形码',
      //         type:'warning'
      //       })
      //     }

      //     Quagga.stop()

      //   })
      // },


      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addOneConsumables()
          } else {
            return false;
          }
        });
      },
      addOneConsumables(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/add';

        var code = this.form.cons_udi;
        var consUdi = ''
        if(code.length == 24){
          const part1 = '(' + code.substring(0,2) + ')' + code.substring(2,8)
          const part2 = '(' + code.substring(8,10) + ')' + code.substring(10,20)
          const part3 = '(' + code.substring(20,22) + ')' + code.substring(22,24)
          consUdi = part1 + part2 + part3;
        }else{
          // this.$message.error('UDI不合规，请确认后再提交');
          this.$message({
            message:'UDI不合规，请确认后再提交',
            type:'warning'
          })
          return;
        }

        const data = {
          "udi":consUdi,
          'entranceDate':this.form.entranceDate,
        }

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'入库成功',
                type:'success'
              });
              this.resetForm('form');
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    mounted() {
    }
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }

    .cons-add{

      .add-form{
        padding: 25px 5px;

        .el-upload-dragger{
          background-color: #1A3F81;
        }

        .el-input__inner{
          float: left;
          background-color: RGBA(17, 58, 113, 0.5);
          border: 2px solid #1D4BB6;
          border-radius: 6px;
          box-shadow: 2px 2px 0 0 rgba(0,0,0,0.2);
          caret-color: rgba(0,255,255,0.8);
          color: #FFFFFF;
          font-size: 15px;
          font-weight: 400;
        }

        .canvas{display: none;}

        //表单验证错误提示偏移
        .el-form-item__error{
          margin-top: -11px;
        }

        .el-descriptions__body{
          // background-color: #00DEFF;
          border: 0px red solid;
        }

        .el-descriptions-item__cell{
          border: 1px #1D4BB6 solid;
        }
          .my-label {
            // background: #E1F3D8;
            background-color: transparent;
            color: rgba(0,255,255,1);
          }

          .my-content {
            // background: #FDE2E2;
          }

          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }
      }
    }

    // .el-form-item__label{
    //   color: #FFFFFF;
    //   font-size: 18px;
    //   // font-family: Microsoft YaHei;
    //   font-weight: 400;
    // }



  }

</style>



// WEBPACK FOOTER //
// src/view/manage/consumables/consumables-add.vue